import React from 'react';
import './Footer.css';

function Footer() {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer className="footer" id="contact">
      <div className="footer-container">
        {/* Left Section - Branding */}
        <div className="footer-branding">
          <div className="footer-logo">
            <img src="/logo.svg" alt="S.C.A.L.P.E.L. Logo" />
          </div>
          <p className="footer-tagline">
            AI-Powered medical learning for students and doctors.
          </p>
          <div className="footer-social">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Facebook">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 2H15C13.6739 2 12.4021 2.52678 11.4645 3.46447C10.5268 4.40215 10 5.67392 10 7V10H7V14H10V22H14V14H17L18 10H14V7C14 6.73478 14.1054 6.48043 14.2929 6.29289C14.4804 6.10536 14.7348 6 15 6H18V2Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="LinkedIn">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 8C17.5913 8 19.1174 8.63214 20.2426 9.75736C21.3679 10.8826 22 12.4087 22 14V21H18V14C18 13.4696 17.7893 12.9609 17.4142 12.5858C17.0391 12.2107 16.5304 12 16 12C15.4696 12 14.9609 12.2107 14.5858 12.5858C14.2107 12.9609 14 13.4696 14 14V21H10V14C10 12.4087 10.6321 10.8826 11.7574 9.75736C12.8826 8.63214 14.4087 8 16 8Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M6 9H2V21H6V9Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M4 6C5.10457 6 6 5.10457 6 4C6 2.89543 5.10457 2 4 2C2.89543 2 2 2.89543 2 4C2 5.10457 2.89543 6 4 6Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Instagram">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M3 16V8C3 5.23858 5.23858 3 8 3H16C18.7614 3 21 5.23858 21 8V16C21 18.7614 18.7614 21 16 21H8C5.23858 21 3 18.7614 3 16Z" stroke="currentColor" strokeWidth="1.5"/>
                <path d="M17.5 7.51L17.51 7.49889" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </a>
          </div>
        </div>

        {/* Navigation Columns */}
        <div className="footer-nav">
          {/* Company Column */}
          <div className="footer-nav-column">
            <h3 className="footer-nav-title">Company</h3>
            <ul className="footer-nav-links">
              <li>
                <a href="https://docplix.com" target="_blank" rel="noopener noreferrer">
                  About DocPlix
                </a>
              </li>
            </ul>
          </div>

          {/* Product Column */}
          <div className="footer-nav-column">
            <h3 className="footer-nav-title">Product</h3>
            <ul className="footer-nav-links">
              <li>
                <a href="#features" onClick={(e) => { e.preventDefault(); scrollToSection('features'); }}>
                  Features
                </a>
              </li>
              <li>
                <a href="#use-cases" onClick={(e) => { e.preventDefault(); scrollToSection('use-cases'); }}>
                  Use Cases
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Column */}
          <div className="footer-nav-column">
            <h3 className="footer-nav-title">Contact</h3>
            <ul className="footer-nav-links">
              <li>
                <a href="#contact" onClick={(e) => { e.preventDefault(); scrollToSection('contact'); }}>
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          {/* Legal Column */}
          <div className="footer-nav-column">
            <h3 className="footer-nav-title">Legal</h3>
            <ul className="footer-nav-links">
              <li>
                <a href="/privacy" target="_blank" rel="noopener noreferrer">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="/terms" target="_blank" rel="noopener noreferrer">
                  Terms & Conditions
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Copyright Section */}
      <div className="footer-bottom">
        <div className="footer-divider"></div>
        <p className="footer-copyright">
          ©2025 DocPlix Solutions Private Limited | All Rights Reserved
        </p>
      </div>
    </footer>
  );
}

export default Footer;
